import { IUserData } from "api/auth";
import { IHackathonResponse } from "api/hackathon";
import { IProject } from "api/project";
import { useQuery, UseQueryOptions } from "react-query";
import {
  getRebakedBlogPostsRequest,
  getPortfolioByUsernameRequest,
  getPortfolioFollowerRequest,
  getPortfolioFollowingRequest,
  getPortfolioHackathonRequest,
  getPortfolioLikeRequest,
} from "./request";
import { IPortfolioResponse, IRebakedPost } from "./types";

export const usePortfolio = (
  username: string,
  option?: UseQueryOptions<IPortfolioResponse, Error>
) => {
  return useQuery<IPortfolioResponse, Error>(
    ["portfolio", username],
    () => getPortfolioByUsernameRequest(username),
    option
  );
};

export const usePortfolioFollower = (
  userId: string,
  option?: UseQueryOptions<IUserData[], Error>
) => {
  return useQuery<IUserData[], Error>(
    ["portfolioFollower", userId],
    () => getPortfolioFollowerRequest(userId),
    option
  );
};

export const usePortfolioFollowing = (
  userId: string,
  option?: UseQueryOptions<IUserData[], Error>
) => {
  return useQuery<IUserData[], Error>(
    ["portfolioFollowing", userId],
    () => getPortfolioFollowingRequest(userId),
    option
  );
};

export const usePortfolioLike = (
  userId: string,
  option?: UseQueryOptions<IProject[], Error>
) => {
  return useQuery<IProject[], Error>(
    ["portfolioLike", userId],
    () => getPortfolioLikeRequest(userId),
    option
  );
};

export const usePortfolioHackathon = (
  userId: string,
  option?: UseQueryOptions<IHackathonResponse[], Error>
) => {
  return useQuery<IHackathonResponse[], Error>(
    ["portfolioHackathon", userId],
    () => getPortfolioHackathonRequest(userId),
    option
  );
};

// export const useMediumRebaked = (
//   option?: UseQueryOptions<IRebakedPost[], Error>
// ) => {
//   return useQuery<IRebakedPost[], Error>(
//     "feed/rebakedinc",
//     () => getMediumRebakedRequest(),
//     option
//   );
// };

export const useRebakedBlogPosts = (
  option?: UseQueryOptions<IRebakedPost[], Error>
) => {
  return useQuery<IRebakedPost[], Error>(
    "feed/rebakedinc",
    () => getRebakedBlogPostsRequest(),
    option
  );
};
